import React, { useState, useEffect } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { isMobile, isAndroid } from 'react-device-detect'
import Web from './pages/Web'
import Mobile from './pages/Mobile'
import Event from './pages/Event'
import PolicyPrivacy from './pages/PolicyPrivacy'
import PolicyService from './pages/PolicyService'

function App() {
    // console.log('isMobile: ',isMobile)
    const [mobile, setMobile] = useState(false)
    // const [downloadUrl, setDownloadUrl] = useState('https://www.apple.com/app-store/')
    const [downloadUrl, setDownloadUrl] = useState('https://play.google.com/store/apps/details?id=rp.project.mooa')

    useEffect(() => {
        setMobile(isMobile)
        if (isAndroid) setDownloadUrl('https://play.google.com/store/apps/details?id=rp.project.mooa')
    }, [])

    return (
        <BrowserRouter>
            <Routes>
                {mobile === true ? 
                    <Route exact path="/" element={<Mobile downloadUrl={downloadUrl} isAndroid={isAndroid} />}/>
                : 
                    <Route exact path="/" element={<Web />}/>
                }
                
                <Route path="event" element={<Event isMobile={isMobile} />}/>
                
                <Route path="policy/privacy" element={<PolicyPrivacy />}/>
                <Route path="policy/service" element={<PolicyService />}/>

                <Route
                    path="*"
                    element={
                        <main style={{ padding: "1rem" }}>
                        <p>There's nothing here!</p>
                        </main>
                    }
                />
            </Routes>
        </BrowserRouter>
    )
}

export default App
